import Vue from 'vue';
import { guid } from '@/mixins/guid';

export default Vue.component('security-password', {
  template: require('./template.html'),
  name: 'security-password',
  mixins: [guid],
  data() {
    return {
      loading: false,
      oldpassword: '',
      password: '',
      confirmpass: '',
      confirmError: false,
      showHintGroup: false,
      inputIsPassword: true,
      editPass: false,
      hint: {
        lc: false,
        uc: false,
        num: false,
        len: false,
        sym: false,
      },
    };
  },
  mounted() {
    this.resetHint();
  },
  methods: {
    resetHint() {
      this.showHintGroup = false;
      this.hint = {
        lc: false,
        uc: false,
        num: false,
        len: false,
        sym: false,
      };
    },
    showHint() {
      if (!this.showHintGroup) {
        this.showHintGroup = true;
      }
      const lc = /^(?=.*[a-z]).+$/;
      const uc = /^(?=.*[A-Z]).+$/; // uppercase letter
      const num = /^(?=.*\d).+$/; // a number
      const sym = /^(?=.*[!@#$%^&*_-]).+$/; // symbol
      const len = /^.{7,}.+$/; // at least 8 chars
      // check lowercase letter
      this.hint.lc = lc.test(this.password);
      // check uppercase letter
      this.hint.uc = uc.test(this.password);
      // check for a number
      this.hint.num = num.test(this.password);
      // check for symbol
      this.hint.sym = sym.test(this.password);
      // check password length
      this.hint.len = len.test(this.password);
    },
    checkConfirm() {
      this.password = this.password.replace(/\s+/g, '');
      if (this.confirmpass.trim() !== '') {
        this.checkPass();
      }
    },
    checkPass() {
      if (this.password === this.confirmpass) {
        this.confirmError = false;
      } else {
        this.confirmError = 'Your passwords do not match.';
      }
    },
    saveSecurity() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.password === this.confirmpass) {
            this.loading = true;
            const notif = {
              id: this.guid(),
              type: 'success',
              message: 'User password updated!',
            };
            try {
              const payload = {
                oldPassword: this.oldpassword,
                newPassword: this.password,
              };
              await this._cognitoChangePassword(payload);
              this.editPass = false;
            } catch (e) {
              notif.type = 'error';
              notif.message = `${e.message || e}. This has been reported.`;
              await this._reportError({
                error: e,
                fn: 'saveSecurity',
              });
            } finally {
              this.loading = false;
              this.$store.dispatch('addNotification', notif);
            }
          } else {
            this.confirmError = 'Your passwords do not match.';
          }
        }
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/security/password/index.js